<template>
  <div class="newtab">
    <div class="container">
      <SearchBar v-if="showComCfg.showSearchBar" v-bind:SearchBar="comCfgData.SearchBar" v-bind:pageType="pageType"></SearchBar>
      <HotWords v-if="showComCfg.showHotWords" v-bind:HotWords="comCfgData.HotWords" v-bind:pageType="pageType"></HotWords>
      <div class="info_flow" id="info_flow" style="display: block;">
        <div class="content-wrapper" id="content-wrapper" :style="'width: 982px;height:' + cntHeight + 'px;min-height: 890px; top: ' + newsTop + 'px;'">
          <div id="page-news" :style="'display: block;' + marginTop">
            <div id="news-container" class="news-container">
              <LeftNews v-if="showComCfg.showLeftNews" v-bind:compsCfg="comCfgData.LeftNews" v-bind:pageType="pageType" v-bind:showNewsTag="showNewsTag"></LeftNews>
              <RightNews v-if="showComCfg.showRightNews" v-bind:compsCfg="comCfgData.RightNews" v-bind:pageType="pageType"></RightNews>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from './components/SearchBar';
import HotWords from './components/HotWords';
import LeftNews from './components/LeftNews';
import RightNews from './components/RightNews';
import util from './api/util';
import cfg from './api/cfg';
import stats from './api/statistics';

export default {
  name: 'App',
  components: {
    SearchBar,
    HotWords,
    LeftNews,
    RightNews
  },
  data () {
    return {
      pageType: '', // 页面类型： newtab --> 新标签页， errorpage--> 错误页
      runEnv: 'test', // 运行环境： test --> 测试或者开发环境, pro --> 生产环境
      showComCfg: {}, // 组件显示配置
      comCfgData: {}, // 各个组件配置数据，会通过props分发到个组件
      showReport: 0,
      showNewsTag: false,
      cntHeight: 980,
      newsTop: 0,
      marginTop: ''
    };
  },
  created: function () {
    this.init();
    this.$bus.$on('refreshHeight', (data) => {
      this.cntHeight = data.curHeight + 50;
    });
    this.$bus.$on('sendMessage', this.sendMessage);
  },
  mounted: function () {
    window.addEventListener('message', (event) => this.getMessage(event));
    if (this.pageType === 'newTab') {
      this.newsTop = -50;
    }
  },
  methods: {
    /**
     * 初始化页面
     */
    init () {
      this.initPageType();
      this.initCmpotntsCfg();
    },
    /**
     * 检测当前页面类型
     */
    initPageType () {
      this.pageType = util.getQueryField('pageType');
      if (this.pageType === 'newtab') {
        this.marginTop = 'margin-top: -61px;';
      }
    },
    /**
     * 获取并初始化组件和配置数据
     */
    initCmpotntsCfg () {
      this.showNewsTag = cfg.getCfg(this.pageType, 'showNewsTag');
      (cfg.getCfg(this.pageType, 'showComps') || []).forEach((compName) => {
        this.showComCfg['show' + compName] = true;
        this.comCfgData[compName] = cfg.getCfg(this.pageType, compName) || {};
      });
    },
    /**
     * 调试方法
     */
    debugLog () {
      if (this.runEnv === 'test') {
        console.log(...arguments);
      }
    },
    handleScroll () {
      this.$bus.$emit('showReport', {
        rect: arguments[0]
      });
    },
    getMessage(e) {
      if (e.data.from === 'newtab') {
        switch (e.data.action) {
          case 'loadData':
            this.handleScroll(e.data.iframeRect);
            this.$bus.$emit('loadMore');
            break;
          case 'scroll':
            this.handleScroll(e.data.iframeRect);
            break;
          case 'loadMore':
            // this.$bus.$emit('loadMore');
            break;
          case 'reportShow':
            // e.data.data && (this.iframeRect = e.data.data);
            this.handleScroll(e.data.data);
            break;
          case 'changeNewsNavState':
            this.showNewsTag = e.data.data.hidden;
            this.sendMessage({
              action: 'refreshScrollTop',
              data:{
                curIndex: this.curIndex
              }
            });
            break;
          case 'refreshIframeRect':
            this.debugLog('refreshIframeRect', e.data.data);
            this.iframeRect = e.data.data
            break;
          case 'refreshTab':
            this.$bus.$emit('refreshTab');
            break;
          case 'changeTab':
            this.$bus.$emit('changeTab', e.data.data);
            break;
          case 'closeTips':
            this.$bus.$emit('closeTips');
            break;
          case 'load_right_top_ad':
            this.$bus.$emit('load_right_top_ad', e.data.data);
            break;
          default:
            this.debugLog('unknown:', e.data.action);
            break;
        }
      }
    },
    sendMessage(msgInfo) {
      msgInfo['from'] = 'newsie.2345.com';
      window.parent.postMessage(msgInfo, '*');
    }
  }
}
</script>
